import normalizer from '@cordel/helpers/form/schema';

import {
  USED,
} from './sections';

import {
  REASON,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [USED]: {
        title: 'Informações',
        subtitle: 'Registe o motivo da retirada',
        hierarchy: 'h3',
      },
    },

    fields: {
      [REASON]: {
        section: USED,
        label: 'Motivo',
        placeholder: 'Selecione um motivo',
        type: 'select',
        options: [
          { label: 'Venda', value: 'venda' },
          { label: 'Troca', value: 'troca' },
          { label: 'Desistência', value: 'desistencia' },
        ],
        validations: [{
          type: 'blank',
        }],
        size: 12,
      },
    },
  });
}
